import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { I18n } from 'react-i18nify';
import RadioSelector from '../../components/common/RadioSelector';
import { changeTemplate } from '../../actions/block_page_settings';
import { getChangedFields } from '../../selectors/block_page_settings';

const mapStateToProps = state => ({
  value: Object.prototype.hasOwnProperty.call(
    state.blockPageSettings.changes,
    'template'
  )
    ? state.blockPageSettings.changes.template
    : state.blockPageSettings.original.template,
  label: I18n.t('blockPage.template.label'),
  disabled: Boolean(
    getChangedFields(state).filter(field => field !== 'template').length
  ),
  options: [
    {
      value: 'default',
      label: I18n.t('blockPage.template.default'),
    },
    {
      value: 'custom',
      label: I18n.t('blockPage.template.custom'),
    },
  ],
  tooltipText: I18n.t('shared.unsaved'),
});

const mapDispatchToProps = dispatch => ({
  handleChange: e => {
    dispatch(changeTemplate(e.target.value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RadioSelector));
